import queryString from 'query-string';
import { apiFetch } from './utils/api';

export const funds = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };
    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `/v2/qlik/funds?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
